import { computed, nextTick, ref, toValue } from 'vue';

const useTextInputHook = (modelValue, inputRef, errorGetter) => {
  const isFocused = ref(false);
  const isAutoFilled = ref(false);

  const isLabelCollapsed = computed(() => !!toValue(modelValue) || isFocused.value || isAutoFilled.value);

  const isErrorMessageVisible = computed(() => {
    const errorConfig = toValue(errorGetter);

    return errorConfig?.error && !!errorConfig?.errorMessage;
  });

  const handleInputAnimation = (e) => {
    isAutoFilled.value = e.animationName === 'onAutoFillStart';
  };

  const addInputAnimationListener = () => {
    nextTick(() => {
      toValue(inputRef)?.addEventListener?.('animationstart', handleInputAnimation);
    });
  };

  const removeInputAnimationListener = () => {
    toValue(inputRef)?.removeEventListener?.('animationstart', handleInputAnimation);
  };

  const handleInputFocus = () => {
    isFocused.value = true;
  };

  const handleInputBlur = () => {
    isFocused.value = false;
  };

  return {
    isLabelCollapsed,
    isErrorMessageVisible,
    addInputAnimationListener,
    removeInputAnimationListener,
    handleInputFocus,
    handleInputBlur,
  };
};

export default useTextInputHook;
